module.exports = __webpack_public_path__ + "img/paper_negative.9da8b9fd.svg";